export default __webpack_public_path__ + "media/images/logos/m_logo_dark-cea50b1df559f1e32988187b270f46b6.png";